import { Calendar, Video, FileText } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      icon: Calendar,
      title: "Book & Pay Online",
      description: "Choose your service and complete the payment securely online. After confirmation, we'll schedule your appointment via WhatsApp."
    },
    {
      icon: Video,
      title: "See Your Doctor",
      description: "Join a secure video call from anywhere in Brazil — your hotel, apartment or office. English-speaking Brazilian doctor with valid CRM."
    },
    {
      icon: FileText,
      title: "Get Your Documents",
      description: "After your consultation, receive any prescriptions, certificates, or treatment recommendations the doctor considers clinically appropriate — digitally signed and valid throughout Brazil."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            How It Works
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
            Getting medical care in Brazil has never been easier. Three simple steps to connect with an English-speaking doctor.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                  <step.icon className="h-10 w-10 text-primary-foreground" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent rounded-full flex items-center justify-center text-accent-foreground font-bold text-sm">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;